import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyCAYdnnuDJbdhxAud-cmUpIENHpqWScw5s",
  authDomain: "bettercallmom.firebaseapp.com",
  projectId: "bettercallmom",
  storageBucket: "bettercallmom.firebasestorage.app",
  messagingSenderId: "611960129274",
  appId: "1:611960129274:web:fba4d0f96906afea04ab43",
  measurementId: "G-S344661MBW"
}

const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
